exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan-modal-title[data-v-7ec7ff48]{background-color:#242428;color:#fff;font-size:16px;font-weight:500;padding:16px 24px}.plan-modal-content[data-v-7ec7ff48]{width:100%;max-height:calc(100vh - 56px);overflow-y:auto}", ""]);

// exports
